<template>
  <v-container>
    <h2>
      <span>CRM Agents Report</span>
    </h2>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form class="form-box">
        <v-row>
          <v-col class="mx-auto" sm="8" cols="12">
            <v-row>
              <v-col class="py-2" cols="12" sm="6">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.from"
                      label="From"
                      regular
                      persistent-hint
                      :append-icon="form.from ? 'mdi-close' : ''"
                      @click:append="clearMenu1"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.from"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-2" cols="12" sm="6">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.to"
                      label="To"
                      regular
                      persistent-hint
                      :append-icon="form.to ? 'mdi-close' : ''"
                      @click:append="clearMenu2"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.to" no-title></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-2" cols="12">
                <v-autocomplete
                  :items="types"
                  item-text="name"
                  item-value="id"
                  regular
                  :append-icon="form.type_id ? 'mdi-close' : ''"
                  @click:append="clearType"
                  label="Employee Type"
                  v-model="form.type_id"
                  :loading="loadingCamps"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-btn
                  v-if="!downloading"
                  class="text-capitalize"
                  large
                  rounded
                  color="error"
                  outlined
                  @click="handleSave()"
                  width="100%"
                  :disabled="$v.form.$invalid"
                  :loading="loadingRequest"
                  ><span>Export</span>
                </v-btn>
                <v-btn
                  class="text-capitalize"
                  large
                  rounded
                  width="100%"
                  color="success"
                  outlined
                  v-else
                  :href="url"
                  @click="download"
                  >Download</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import { ExportData, IndexDataQuery } from "@/helpers/apiMethods";
// import { required } from "vuelidate/lib/validators";
// import FileSaver from "file-saver";
export default {
  data() {
    return {
      form: {},
      types: [],
      downloading: false,
      loadingRequest: false,
      loadingCamps: false,
      menu1: false,
      menu2: false,
      loadingData: false,
      globalServerErrors: null
    };
  },

  created() {
    this.indexLists();
  },
  methods: {
    indexLists() {
      this.loadingCamps = true;
      IndexDataQuery({ reqName: `/employee-types` })
        .then(res => {
          const { data } = res.data;
          this.types = data;
          // console.log(res);
          this.loadingCamps = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleSave() {
      this.familyExport();
    },
    familyExport() {
      this.loadingRequest = true;
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        if (this.form[formItem] == "") {
          return;
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      formData.append("download", "");
      ExportData({
        reqName: `reports/crm-agents-report`,
        data: formData
      })
        .then(res => {
          this.url = res.data.url;
          this.loadingRequest = false;
          this.downloading = true;
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {
          this.loadingRequest = false;
        });
    },
    download() {
      this.downloading = false;
      this.form = {};
    },
    reset() {
      this.$v.form.$reset();
      (this.form = {
        id: "",
        value_type: ""
      }),
        this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    clearMenu1() {
      this.form.from = "";
    },
    clearMenu2() {
      this.form.to = "";
    },
    clearCashier() {
      this.form.cashier_id = "";
    },
    clearType() {
      this.form.type_id = "";
    }
  },
  validations: {
    form: {}
  }
};
</script>
